import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import moment from 'moment';
import { cloneDeep } from 'lodash';
import { forkJoin } from 'rxjs';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { EmployeeInfoService } from '../../../core/services/employee-info.service';
import { PortalSettingsService } from '../../../core/services/portal-settings.service';
import { EmployeeService } from './../../../pages/employee/services/employee.service';
import { ApprovalService } from './../../../pages/approval/services/approval.service';

@Component({
  selector: 'app-edit-dependent-modal',
  templateUrl: './edit-dependent-modal.component.html',
  styleUrls: ['./edit-dependent-modal.component.css']
})
export class EditDependentModalComponent implements OnInit {
  @ViewChild('dependForm', { static: false }) dependForm: NgForm;
  @Input() dependent: any;
  @Input() mode: string;
  @Input() userID: number | null;
  mobileMode: boolean;
  portalSettings: any;
  employeeInfo: any;
  format: string;
  formData: { [key: string]: any } = {};
  originalData: { [key: string]: any } = {};
  gettingFilesData: boolean = false;
  savingDependent: boolean = false;
  btmText: any;
  newBornSSN: boolean;
  docsRequired: boolean;
  phoneMask: any;
  ssnMask: any;
  attachedFiles: number;
  savedFiles: any[];
  newFiles: any[];
  fileData: any[];
  relationshipList: any[] = [];
  hRDPKeyID: number;
  keyID: number;
  fields: any[] = [];
  groupedFields: any[] = [];
  dependentRequestID: number;
  isSubmitting: boolean;
  alert: any;
  validComboDrag: any;
  dragFiles: any;
  isLoading: boolean = true;
  fieldsToBind: number = 0;
  datePickerOptions: { dateInputFormat: string; containerClass: string; showTodayButton: boolean; showClearButton: boolean; clearPosition: string; showWeekNumbers: boolean };

  constructor(public activeModal: NgbActiveModal, portalSettingsService: PortalSettingsService, employeeInfoService: EmployeeInfoService, private employeeService: EmployeeService, private approvalService: ApprovalService) {
    this.portalSettings = portalSettingsService.getPortalSettings();
    this.employeeInfo = employeeInfoService.getEmployeeInfo();
  }

  ngOnInit(): void {
    if (this.portalSettings["CountryDateCode"].ConfigValue == "US") {
      this.format = "MM/DD/YYYY";
    }
    else {
      this.format = "DD/MM/YYYY";
    }
    this.datePickerOptions = { dateInputFormat: this.format.toUpperCase(), containerClass: "theme-blue", showTodayButton: true, showClearButton: true, clearPosition: "left", showWeekNumbers: false };
    this.mobileMode = this.mobileAndTabletcheck();
    this.btmText = this.portalSettings.DependentBtmText.ConfigValue;
    this.newBornSSN = this.portalSettings.NewBorn30SSNNotRequire.ConfigValue == "1";
    this.docsRequired = this.portalSettings.DependentRequiresDocs.ConfigValue == "1";
    this.formData = {};
    this.originalData = {};
    this.gettingFilesData = false;
    this.savingDependent = false;
    this.phoneMask = this.portalSettings.PhoneMask.ConfigValue;
    this.formData.notes = "";
    //set SSN Mask
    switch (this.employeeInfo.EmplCountry) {
      case "US":
        this.ssnMask = "999-99-9999";
        break;
      case "CA":
        this.ssnMask = "999-999-999";
        break;
      default:
        this.ssnMask = "999-99-9999";
        break;
    }
    this.attachedFiles = 0;
    this.savedFiles = [];
    this.hRDPKeyID = this.dependent.KeyID;
    this.getRelationship();
    if (this.mode == "approval")
      this.keyID = this.dependent.HRDPKeyID;
    else if (this.mode == "attachmentOnly") {
      this.keyID = this.dependent.DependentRequestID;
    }
    else
      this.keyID = this.dependent.KeyID;
    var isAddressValidationEnabled = false;
    this.newFiles = [];
  }

  private mobileAndTabletcheck() {
    var check = false;
    (function (a) { if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true })(navigator.userAgent || navigator.vendor);
    return check;
  }

  private getRelationship() {
    this.employeeService.getRelationship().then((response: any) => {
      this.relationshipList = [];
      response.forEach((val: any) => {
        this.relationshipList.push({ name: val, value: val });
      });
      this.getUserFields();
    });
  }

  checkSSN(field) {
    if (this.formData[field.FieldVPColumnName] != null) {
      if (this.formData[field.FieldVPColumnName].length != 11)
        this.formData[field.FieldVPColumnName] = null;
    }
  }

  addAttachment() {
    this.newFiles.push({ File: null, Filename: null });
  }

  deleteUnsavedAttachment = function (file) {
    var index = this.newFiles.indexOf(file);
    this.newFiles.splice(index, 1);
  }

  numDaysBetween(d1, d2) {
    var diff = Math.abs(d1.getTime() - d2.getTime());
    return diff / (1000 * 60 * 60 * 24);
  }

  check30Days = function (data) {
    if (data != null) {
      if (this.newBornSSN) {
        if (this.numDaysBetween(new Date(), data) < 31)
          this.ssnNotRequireOverride = true;
        else
          this.ssnNotRequireOverride = false;
      }
    }
  }

  private getUserFields() {
    this.employeeService.getDependentFields(this.keyID).then((response: any) => {
      this.fields = response;
      this.groupedFields = [];
      var temp = [];
      for (var i = 0; i < this.fields.length; i++) {
        if (this.fields[i].FieldDataType == 4) {
          if (this.fields[i].FieldValue != null) {
            var dateParts = this.fields[i].FieldValue.split("-");
            var date = new Date(dateParts[0], dateParts[1] - 1, dateParts[2]);
            date.setHours(0, 0, 0, 0);
            this.formData[this.fields[i].FieldVPColumnName] = date;
            this.check30Days(date);
          }
        }
        else {
          if (this.fields[i].FieldDataType == 5) {
            this.fieldsToBind++;
            this.getFieldOptions(this.fields[i]);
          }
          if (this.fields[i].FieldVPColumnName == "Relationship") {
            if (this.relationshipList.length > 0) {
              for (let j = 0; j < this.relationshipList.length; j++) {
                if (this.relationshipList[j].value == this.fields[i].FieldValue) {
                  this.formData[this.fields[i].FieldVPColumnName] = this.fields[i].FieldValue;
                  break;
                } else {
                  this.formData[this.fields[i].FieldVPColumnName] = null;
                }
              }
            } else {
              this.formData[this.fields[i].FieldVPColumnName] = this.fields[i].FieldValue;
            }
          } else
            this.formData[this.fields[i].FieldVPColumnName] = this.fields[i].FieldValue;
        }
        if (i > 0 && i % 2 == 0) {
          this.groupedFields.push(temp);
          temp = [];
        }
        temp.push(this.fields[i]);
      }
      if (this.mode == "approval") {
        if (this.dependent.DependentFieldData != "") {
          var dependentFieldData = this.dependent.DependentFieldData.DependentInformation.DependentField;
          //if only one field has changed, dependentFieldData is an object, else it is an array
          if (Object.prototype.toString.call(dependentFieldData) === '[object Array]') {
            dependentFieldData.forEach((val: any) => {
              if (val.Name == "BirthDate") {
                this.formData[val.Name] = new Date(parseInt(moment(val.Value).format("YYYY")), parseInt(moment(val.Value).format("MM")) - 1, parseInt(moment(val.Value).format("DD")), 0, 0, 0, 0);
              }
              //#410452: Handling other dates fields in the screen
              else if (moment(val.Value, 'YYYY-MM-DD', true).isValid()) {
                this.formData[val.Name] = new Date(parseInt(moment(val.Value).format("YYYY")), parseInt(moment(val.Value).format("MM")) - 1, parseInt(moment(val.Value).format("DD")), 0, 0, 0, 0);
              } else {
                this.formData[val.Name] = val.Value;
              }
            });
          }
          else {
            if (dependentFieldData.Name != null && dependentFieldData.Value != null) {
              if (dependentFieldData.Name == "BirthDate") {
                this.formData[dependentFieldData.Name] = new Date(parseInt(moment(dependentFieldData.Value).format("YYYY")), parseInt(moment(dependentFieldData.Value).format("MM")) - 1, parseInt(moment(dependentFieldData.Value).format("DD")), 0, 0, 0, 0);
              } if (moment(dependentFieldData.Value, 'YYYY-MM-DD', true).isValid()) {
                this.formData[dependentFieldData.Name] = new Date(parseInt(moment(dependentFieldData.Value).format("YYYY")), parseInt(moment(dependentFieldData.Value).format("MM")) - 1, parseInt(moment(dependentFieldData.Value).format("DD")), 0, 0, 0, 0);
              } else {
                this.formData[dependentFieldData.Name] = dependentFieldData.Value;
              }
            } 
          }
        }
        this.getSavedAttachments();
      }
      this.originalData = cloneDeep(this.formData);
      if (this.fieldsToBind == 0) {
        this.isLoading = false;
      }
      if (temp.length > 0) {
        this.groupedFields.push(temp);
      }
    });
  }

  getSavedAttachments() {
    var requestParam = "moduleID=" + 29 + "&recordID=" + this.dependent.DependentRequestID;
    this.employeeService.getFileAttachmentList(requestParam).then((response: any) => {
      this.savedFiles = response;
    });
  }

  private getFieldOptions(field) {
    this.employeeService.getFieldOptions(field.FieldID).then((response: any) => {
      field.fieldOptions = [];
      field.fieldOptions[field.FieldVPColumnName] = response;
      this.fieldsToBind--;
      if (this.fieldsToBind == 0) {
        this.isLoading = false;
      }
    });
  }

  cancelClicked() {
    this.activeModal.close('close');
  }

  saveClicked() {
    this.savingDependent = true;
    this.closeAlert();
    var postData = [];
    var changedKeys = [];

    //Get changed data
    for (let [key, value] of Object.entries(this.formData)) {
      if (this.originalData[key] !== value && !this.areDatesEqual(this.originalData[key], value)) {
        if (key.toLowerCase().indexOf("date") > -1 && value != null) {
          //ISO date string is always in format of YYYY-MM-DDTHH:mm:ss.sssZ
          value = moment(value).toISOString(true);
          value = value.substr(0, value.indexOf("T"));
        }
        if (key.toLowerCase().indexOf("phone") > -1 && key.toLowerCase().indexOf("carrier") == -1) {
          if (value == this.phoneMask) {
            value = "";
          }
        }
        if (key != "fileDrop") {
          postData.push({ Name: key, Value: value });
          changedKeys.push(key);
        }
      }
    }
    //If data was changed, submit
    this.isSubmitting = true;
    this.employeeService.submitDependents(this.dependent.KeyID, postData, false, this.userID).then((response: any) => {
      if (response.success) {
        this.dependentRequestID = response.dependentRequestID;
        if (this.dependentRequestID != null) {
          this.saveAttachments();
        }
        else {
          this.savingDependent = false;
          this.activeModal.close({ type: "success", msg: "Dependent information updated successfully." });
        }
      }
      else {
        this.savingDependent = false;
        this.alert = { type: "danger", msg: "An error occurred while updating dependent information." }
      }
    });

  }

  private readFile(file: any, call: any) {
    var reader = new FileReader();
    reader.onload = function (e) { return call(e, file.name) };
    reader.readAsDataURL(file);
  }

  upload() {
    this.fileData = [];
    var currentUpload = this.formData.fileDrop;
    this.formData.fileDrop = [];
    for (var i = 0; i < currentUpload.length; i++) {
      currentUpload[i].nameEdit = "";
      for (var y = 0; y < currentUpload[i].name.substr(0, currentUpload[i].name.lastIndexOf('.') + 1).length; y++) {
        if (currentUpload[i].name[y] != " " && currentUpload[i].name[y] != "&" && currentUpload[i].name[y] != "*" && currentUpload[i].name[y] != ":" &&
          currentUpload[i].name[y] != ";" && currentUpload[i].name[y] != "|" && currentUpload[i].name[y] != "=" && currentUpload[i].name[y] != "," &&
          currentUpload[i].name[y] != "." && currentUpload[i].name[y] != "/" && currentUpload[i].name[y] != "\"" && currentUpload[i].name[y] != "[" &&
          currentUpload[i].name[y] != "]")
          currentUpload[i].nameEdit += currentUpload[i].name[y];
      }
      currentUpload[i].nameEdit += currentUpload[i].name.substr(currentUpload[i].name.lastIndexOf('.'), currentUpload[i].name.length);
    }

    if (currentUpload != null) {
      for (var i = 0; i < currentUpload.length; i++) {
        var n = 0;
        this.readFile(currentUpload[i], (e: any, fileName: string) => {
          setTimeout(() => {
            this.fileData.push({ data: e.target.result.toString().split(","), size: e.total, name: fileName });
            if (n == (currentUpload.length - 1)) {
              this.fileData.forEach((val: any) => {
                currentUpload.forEach((val2: any) => {
                  if (val2.size == val.size && val.name == val2.name) {
                    this.newFiles.push({ File: val.data[1], Filename: val2.nameEdit, Filedata: val2, Type: val.data[0].split("/")[0] });
                  }
                });
              });
            }
            n++;
          });
        });
      };
    }
  }

  saveAttachments() {
    var promises = [];
    if (this.mode == "attachmentOnly" || this.mode == "approval") {
      this.dependentRequestID = this.dependent.DependentRequestID;
    }
    this.newFiles.forEach((attachment: any) => {
      if (attachment.File != null && attachment.Filename != null) {
        promises.push(this.employeeService.saveFileAttachment(29, this.dependentRequestID, attachment.File, attachment.Filename, "file", null, null, null).then((response: any) => {
        }));
      }
    });
    forkJoin(promises).subscribe({
      complete: () => {
        this.savingDependent = false;
        this.activeModal.close({ type: "success", msg: "Dependent information updated successfully." });
      }
    });
  }

  approveClicked() {
    this.gettingFilesData = true;
    this.closeAlert();
    var postData = [];
    var changedKeys = [];
    var list = [];
    //Get changed data
    this.formData.forEach((value: any, key: any) => {
      if (this.originalData[key] !== value && !this.areDatesEqual(this.originalData[key], value)) {
        //#410452: Handling other dates fields in the screen
        if (moment(value, 'YYYY-MM-DD', true).isValid()) {
          value = moment(value).format("YYYY-MM-DD");
        }
        postData.push({ Name: key, Value: value });
        changedKeys.push(key);
      }
    });

    this.isSubmitting = true;

    //toVPFile
    this.approvalService.dependentRequestAction(this.dependent.DependentRequestID, postData, "A", this.formData.notes).then((response: any) => {
      if (response.success) {
        this.saveAttachments();
        if (this.savedFiles.length > 0) {
          this.employeeService.sendFileAttachmentRawDataToVP(29, this.dependent.DependentRequestID, "file", null, null, null, null).then((response: any) => {
            this.gettingFilesData = false;
            if (response.success) {
              this.activeModal.close({ type: "success", msg: "Dependent request approved." });
            }
          });
        }
      }
      else {
        this.alert = { type: "danger", msg: "An error occurred while approving the request." }
      }
    });
  }

  deleteClicked() {
    this.employeeService.submitDependents(this.dependent.KeyID, null, true, this.userID).then((response: any) => {
      this.activeModal.close({ type: "danger", msg: "Your request to remove a dependent has been submitted." });
    });
  }

  rejectClicked() {
    this.approvalService.dependentRequestAction(this.dependent.DependentRequestID, [], "R", this.formData.notes).then((response: any) => {
      if (response.success) {
        this.activeModal.close({ type: "success", msg: "Dependent request rejected." });
      }
      else {
        this.alert = { type: "danger", msg: "An error occurred while rejecting the request." }
      }
    });
  }

  areDatesEqual(date, date2) {
    return !date && !date2 || date && date2 && date.getMonth && date.getTime() === date2.getTime();
  }

  closeAlert() {
    this.alert = null;
  }

  updatePhone(data: string, field: any) {
    this.formData[field] = data;
  }

  updateSSN(data: string, field: any) {
    this.formData[field] = data;
  }
}
